import { sdk } from "@/api/sdk";
import { extractLocaleFromCookie, getLocale, isLocale, setLocale } from "@/paraglide/runtime.js";
import { appLanguageOf } from "@complete-athlete/enums";

/** Whose language was already lined up since the app loaded: it happens once per sign-in, not per page. */
let alignedUserId: string | null = null;

/**
 * Lines this device up with the account, once per sign-in (ADR 0026). An account that never
 * picked a language learns the one in use here, so its emails follow it. One that did wins over a
 * device that never chose (a new phone) or that chose differently before the account changed on
 * another device, and the page reloads in it. A `/pl` link opened on a device that agrees with the
 * account is left as it is: a prefix in the address always wins.
 */
export const alignAccountLocale = async (user: { id: string; locale: string | null }) => {
  if (alignedUserId === user.id) return;
  alignedUserId = user.id;

  if (!user.locale || !isLocale(user.locale)) {
    const inUse = appLanguageOf(getLocale());
    if (inUse) await sdk.users.me.locale.$put.send({ payload: { locale: inUse } });
    return;
  }
  if ((extractLocaleFromCookie() ?? getLocale()) !== user.locale) await setLocale(user.locale);
};
